<template>
	<datetime 
		class="fts-date-time"
		:type='type'
		:use12-hour="true"
		:minute-step="1"
		:format="format"
		:value-zone="'local'"
		input-class="fts-form-control"
		:input-id="`ftsDateTime${id}`"
		v-model="model"
		@close="$emit('close')"
		ref="ftsDateTime"
	>
		<font-awesome-icon slot="before" class="remove-date-time" :icon="['fas', 'times']" v-if="model" @click.stop="clearDateTime" />
	</datetime>
</template>
<script>
import Vue from 'vue'
import Datetime from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import commons from '../commons/commons'

Vue.use(Datetime)

export default {
	props: {
		item: Object,
		formData: Object,
		appendToBody: Boolean
	},
	data: () => ({
		id: null
	}),
	methods: {
		clearDateTime() {
			this.formData[this.item.fieldName] = null
		},
	},
	computed: {
		model: {
			get() {
				return this.formData[this.item.fieldName];
			},
			set(val) {
				this.$set(this.formData, this.item.fieldName, val);
			}
		},
		itemInput() {
			if (!commons.isInteger(this.item.type) || this.item.custom) {
				return this.item.input;
			}
		},
		type() {
			if ((this.item.predefinedFormatId === 't' && this.item.type == 6) || this.itemInput == 'time')
				return 'time';
			else if (this.item.type == 6 || this.itemInput == 'dateTime') 
				return 'datetime'
			else
				return 'date';
		},
		format() {
			if (this.item.predefinedFormatId) {
				return commons.dateFormatTranslate(this.item.predefinedFormatId)
			} else if (this.item.type == 5 || this.itemInput == 'date') {
				return commons.dateFormatTranslate("DD")
			} else if (this.item.type == 6 || this.itemInput == 'dateTime') {
				return commons.dateFormatTranslate("DD t")
			} else if (this.itemInput == 'time') {
				return commons.dateFormatTranslate("t")
			}
		}
	},
	watch: {
		model(val, oldVal) {
      if ((val && !oldVal) || (!val && oldVal) && val != oldVal) 
				this.$emit('input', val);
    }
	},
	mounted() {
		this.id = this._uid
		if (this.appendToBody)
			try {
				document.body.appendChild(this.$refs.ftsDateTime.$children[0].$el);
			} catch(err) {
				console.warn('Vue error. Failed to append child')
			}
	},
	beforeDestroy() {
		if (this.appendToBody)
			try {
				document.body.removeChild(this.$refs.ftsDateTime.$children[0].$el);
			} catch(err) {
				console.warn('Vue error. Failed to remove child')
			}
	}
}
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

$hoverColor: var(--fts-gray-2);

.fts-date-time {
	position: relative;
	// Input
	.vdatetime-input {
		padding-right: 2rem;
	}
	.remove-date-time {
		position: absolute;
		top: 50%;
		right: .75rem;;
		transform: translate(0, -50%);
		-webkit-transform: translate(0, -50%);
		-moz-transform: translate(0, -50%);
		-ms-transform: translate(0, -50%);
		font-size: .75rem;
		color: var(--fts-gray-5);
		&:hover {
			cursor: pointer;
			color: var(--fts-danger);
		}
	}
}
// Popup
.vdatetime-popup {
	background: var(--fts-background);
	color: var(--fts-text);
	overflow: auto;
	.vdatetime-popup__header {
		background: $primaryColor !important;
	}
}
// Year
.vdatetime-year-picker__item--selected {
	color: $primaryColor !important;
}
.vdatetime-year-picker__item:hover {
	background: $hoverColor;
}
// Month
.vdatetime-month-picker__item--selected {
	color: $primaryColor !important;
}
.vdatetime-month-picker__item:hover {
	background: $hoverColor;
}
.vdatetime-calendar__month__day:hover > span > span {
	background: $hoverColor;
}
.vdatetime-calendar__month__day--selected > span > span, 
.vdatetime-calendar__month__day--selected:hover > span > span {
	background: $primaryColor !important;
}
// Time
.vdatetime-time-picker__item--selected {
	color: $primaryColor !important;
}
.vdatetime-time-picker__item:hover {
	background: $hoverColor;
}
.vdatetime-popup__actions__button {
	color: $primaryColor !important;
}

/* media query */
@media screen and (min-height: 550px) {
	.vdatetime-popup {
		top: 55px;
		transform: translateX(-50%);
	}
}
@media screen and (max-height: 549.98px) {
	.vdatetime-popup {
		max-height: 100%;
	}
}
</style>